export default "__VITE_ASSET___w1t4zn9__"